export default "__VITE_ASSET__D63BM_wT__"